export const tabItemProps = {
    py: '2',
    px: '4',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: "48px",
    // variant: 'primary',
}

export const tabItemContentContainerStyles = {
    alignItems: 'center',
    justifyContent: 'center',
} as const;

export const tabItemIconStyles = {
    color: 'muted.700',
};

